import { Divider, Grid, Stack } from '@mui/joy';
import type { Dayjs } from 'dayjs';
import { type ReactElement, useState } from 'react';
import { convertDateInUtcToUTCISODate } from 'components/date.utils';
import { getDefaultRange } from 'components/predefinedDateRanges';

import type { SelectedChartElement } from 'components/technical/charts/HighChartsWrapper/Highchart.utils';
import HeaderBar from 'components/technical/HeaderBar/HeaderBar.tsx';
import { usePortfolioFilters } from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters.tsx';
import { PortfolioSnapshotBalanceChart } from './PortfolioSnapshotBalanceChart.tsx';
import PortfolioSnapshotSunburstContainer from './sunburst/PortfolioSnapshotSunburstContainer.tsx';
import { usePortfolioTwrQuery } from '../../../generated/graphql';
import { convertDateRangeToSinceToDate } from 'components/dateRange.utils.ts';
import BaseCard from 'components/technical/GCard/BaseCard.tsx';

const PortfolioSnapshotContainer = (): ReactElement => {
  const defaultDateRange = getDefaultRange();
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs] | null>(defaultDateRange.value());
  const { portfolioFilters } = usePortfolioFilters();

  const queryOutput = usePortfolioTwrQuery({
    variables: {
      dates: convertDateRangeToSinceToDate(dateRange),
      subAccountAssetFilters: portfolioFilters,
    },
  });

  const [sunburstDate, setSunburstDate] = useState<Dayjs>(defaultDateRange.value()![1]);

  return (
    <Stack gap={0}>
      <HeaderBar level="h3" hideBottomPadding title="Portfolio equity" />
      <BaseCard transparent>
        <Grid container spacing={5}>
          <Grid xs={12} sm={8}>
            <PortfolioSnapshotBalanceChart
              setDateRange={(range) => {
                setSunburstDate(range?.[1] ?? defaultDateRange.value()![1]);
                setDateRange(range);
              }}
              onElementSelected={(element: SelectedChartElement): void => setSunburstDate(element.xValue)}
              queryOutput={queryOutput}
            />
          </Grid>
          <Divider
            sx={{ height: '90%', marginY: 'auto', display: { xs: 'none', sm: 'block' } }}
            orientation="vertical"
          />
          <Grid sm={4} sx={{ height: '90%', marginY: 'auto', display: { xs: 'none', sm: 'block' } }}>
            <PortfolioSnapshotSunburstContainer
              portfolioFilters={portfolioFilters}
              date={convertDateInUtcToUTCISODate(sunburstDate)}
            />
          </Grid>
        </Grid>
      </BaseCard>
    </Stack>
  );
};

export default PortfolioSnapshotContainer;
